<template>
  <div>
    <MainText class="title" text="Background" />
    <p>
      I was born in Nanjing, China, and graduated from the
      <Link
        path="http://cpho.tss.nsfz.net/"
        text="High School Affiliated to Nanjing Normal University"
      />
      in 2016. I initially studied Atmospheric Science at the
      <Link
        path="https://cwxy.nuist.edu.cn/"
        text="Changwang School of Honors"
      />
      at
      <Link
        path="https://www.nuist.edu.cn/"
        text="Nanjing University of Information Science & Technology"
      /> for two years, where I developed a strong interest in Computer Science
      (though I remain fascinated by Atmospheric Science).
    </p>
    <p>
      In 2018, I transferred to
      <Link
        path="https://wustl.edu/"
        text="Washington University in St. Louis"
      />
      and earned my Bachelor's degree in Computer Science in 2020.
      Currently, I am pursuing a PhD at WashU under the guidance of Prof.
      <Link path="https://rochguerin.github.io/" text="Roch Guerin" />.
    </p>
    <p>
      For more details, please refer to my
      <Link
        path="https://qiujiaming315.github.io/data/Jiaming_Qiu_CV20240919.pdf"
        text="Curriculum Vitae"
      />.
    </p>
  </div>
</template>

<script>
import MainText from "../components/MainText";
import Link from "../components/Link";

export default {
  name: "Background",
  components: {
    MainText,
    Link,
  },
};
</script>

<style scoped>
div {
  position: absolute;
  top: 90px;
  left: 360px;
  padding-left: 60px;
  padding-right: 90px;
}
p {
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  color: #212325;
  font-size: 20px;
  line-height: 150%;
  text-align: justify;
}
a {
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  color: #66ccff;
  font-size: 20px;
}
@media (max-width: 1000px) {
  div {
    top: 120px;
    left: 0;
    padding-right: 60px;
  }
  p {
    font-size: 18px;
  }
  p.title {
    font-size: 30px;
    margin-bottom: 20px;
  }
  a {
    font-size: 18px;
  }
}
@media (max-width: 600px) {
  div {
    padding-left: 30px;
    padding-right: 30px;
  }
  p {
    font-size: 15px;
  }
  p.title {
    font-size: 25px;
    margin-bottom: 15px;
  }
  a {
    font-size: 15px;
  }
}
</style>